import { render } from "./Heading.vue?vue&type=template&id=34ecc42d&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=ts"
export * from "./Heading.vue?vue&type=script&lang=ts"

import "./Heading.vue?vue&type=style&index=0&id=34ecc42d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34ecc42d"

export default script